// src/utils/eventBus.js
import Vue from 'vue';

// 创建一个新的Vue实例作为事件总线
const EventBus = new Vue();

/**
 * 触发全局事件
 * @param {string} eventName 事件名称
 * @param {*} payload 事件负载数据
 */
export const emitEvent = (eventName, payload) => {
	EventBus.$emit(eventName, payload);
};

/**
 * 监听全局事件
 * @param {string} eventName 事件名称
 * @param {function} callback 回调函数
 */
export const listenEvent = (eventName, callback) => {
	EventBus.$on(eventName, callback);
};

/**
 * 移除事件监听
 * @param {string} eventName 事件名称
 * @param {function} callback 回调函数
 */
export const removeListener = (eventName, callback) => {
	EventBus.$off(eventName, callback);
};

export default EventBus;